import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import DropDownMenu from '../components/DropDownMenu';
import EditMissionsQuestionnaireSection from './components/EditMissionsQuestionnaireSection';
import _ from 'lodash';
import { fetchQuestionnaireById, updateQuestionnaireById } from '../../services/pquestionnaires.service';

function Component(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setdata] = useState(null)
  const [isLoading, setisLoading] = useState(false)

  const fetchData = async () => {
    if (isLoading) return
    setisLoading(true)
    let result = await fetchQuestionnaireById(props.token.token, id);
    if (result.result) {
      setdata(result.result)
    } else {
      alert('Fetch data error')
    }
    setisLoading(false)
  }

  const handleSave = async () => {
    if (isLoading) return
    setisLoading(true)
    let result = await updateQuestionnaireById(props.token.token, id, {
      name: data.name || '',
      enable_2: true,
      time_2: Number(data.time_2) || 20,
      questionnaires2: data.questionnaires2 || [],
    });
    if (result.errno) {
      alert(result.message)
    } else {
      alert('儲存成功')
    }
    setisLoading(false)
  }

  const handleUpdateField = (field) => (e) => {
    setdata({ ...data, [field]: e.target.value })
  }

  useEffect(() => {
    fetchData()
  }, [id])






  {/*questionnaires handler*/ }
  const handleSectionQuestionnaireOrder = (oldLayout, newLayout) => {
    let array = []
    newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
    for (let i of newLayout) {
      let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
      array.push(data.questionnaires2[oldIndex]);
    }
    let d = { ...data };
    d.questionnaires2 = array;
    setdata(d);
  }
  const handleSectionAddQuestionnaire = () => {
    let d = { ...data };
    let questionnaires2 = [...(d.questionnaires2||[])]
    questionnaires2.push({ id: Date.now() })
    d.questionnaires2 = questionnaires2
    setdata(d);
  }
  const handleSectionDeleteQuestionnaire = (card, cardIndex) => {
    let d = { ...data }
    let questionnaires2 = d.questionnaires2;
    questionnaires2.splice(cardIndex, 1);
    d.questionnaires2 = questionnaires2;
    setdata(d)
  }
  const handleSectionEditQuestionnaire = (card, cardIndex, key, value) => {
    let d = { ...data };
    d.questionnaires2[cardIndex][key] = value
    setdata(d);
  }
  {/*questionnaires handler*/ }



  return (
    <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]' style={{ overflowY: "auto" }}>
      {/*buttons*/}
      <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
        <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate('/platform/questionnaires') }}>{`<`} 返回</div>
        <div className='flex flex-row gap-[8px] flex-wrap '>
          {/* <div className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>刪除</div> */}
          {/* <div className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>複製</div> */}
          <div onClick={handleSave} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>儲存</div>
        </div>
      </div>
      {/*end of buttons*/}

      <div className='w-full flex flex-row gap-[8px] mt-[16px] flex-wrap'>
        <div className='w-full flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>問卷名稱</div>
          <input value={data?.name || ''} onChange={handleUpdateField('name')} placeholder='問卷名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>

        <div className='flex-[2] flex flex-col min-w-[300px] max-w-[300px] gap-[8px]'>
          <div className='font-[700] mt-[16px]'>時間</div>
          <DropDownMenu minWidth={100} select={(time) => {
            setdata({ ...data, time_2: Number(time.split('分鐘')[0]) })
          }} options={['5分鐘', '10分鐘', '15分鐘', '20分鐘', '25分鐘', '30分鐘']} value={`${data?.time_2 || '-'} 分鐘`} />
        </div>
      </div>



      <div className='font-[700] mt-[16px]'>問卷調查 </div>
      <div className='w-full bg-white rounded-[10px] py-[16px] flex flex-col gap-[4px]'>
        <EditMissionsQuestionnaireSection
          data={{...data, questionnaires: data?.questionnaires2 || []}}
          updateOrder={handleSectionQuestionnaireOrder}
          onAddCard={handleSectionAddQuestionnaire}
          onEditKey={handleSectionEditQuestionnaire}
          onDelete={handleSectionDeleteQuestionnaire}
        />
      </div>

      {isLoading && <LoadingPage />}
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
